import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { FaSearch } from "react-icons/fa";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { formatDistanceToNow } from "date-fns";

import { loadOpenTicketsDep } from "../../redux/tasks/ticketsT";
import TopBar from "../../components/TopBar";
import Sidebar from "../../components/Sidebar";
import Spinner from "../../components/Spinner";
import Table from "../../components/Table";

const TicketsOpen = ({ loading, user, tickets, loadOpenTicketsDep }) => {
  const navigate = useNavigate();
  const [numberOptions] = useState([5, 10, 15, 20, 25, 30]);
  const [globalFilter, setGlobalFilter] = useState("");

  useEffect(() => {
    loadOpenTicketsDep();
  }, [loadOpenTicketsDep]);

  const handleData = (index) => {
    const ticket = tickets[index];
    navigate("/single-ticket", { state: { ticket } });
  };

  const TableColumns = [
    {
      Header: "#",
      accessor: "ticketNo",
      Cell: ({ value, row }) => {
        const seenBy = row.original.seenBy;
        const isSeenByUser = Array.isArray(seenBy) && seenBy.includes(user._id);
        return (
          <div className="flex items-center gap-1">
            <span
              className={`h-1.5 w-1.5 rounded-full ${
                !isSeenByUser ? "bg-red-600" : "invisible"
              } animate-pulse`}
            />

            <span>{value}</span>
          </div>
        );
      },
    },
    {
      Header: "Subject",
      accessor: "subject",
    },
    {
      Header: "Status",
      accessor: "status",
      Cell: ({ value }) => {
        return value === "WORKINPROGRESS"
          ? "Work in Progress"
          : value === "MARKEDASRESOLVED"
            ? "Marked as Resolved"
            : value === "RESOLVED"
              ? "Closed"
              : value === "ESCALATETOMANAGER"
                ? "Escalated to manager"
                : value === "ESCALATETODOO"
                  ? "Escaalated to DOO"
                  : value === "ESCALATETODEPHEAD"
                    ? "Escaalated to department head"
                    : "Un Assigned";
      },
    },
    {
      Header: "Priority",
      accessor: "priority",
      Cell: ({ value }) => {
        let textColor = "blue";

        switch (value?.toLowerCase()) {
          case "high":
            textColor = "#ef4444"; // red-500
            break;
          case "medium":
            textColor = "#f59e0b"; // amber-500
            break;
          case "low":
            textColor = "#10b981"; // green-500
            break;
          default:
            textColor = "black";
        }

        return (
          <span
            style={{
              color: textColor,
              // padding: "4px 8px",
              // borderRadius: "12px",
              // textTransform: "capitalize",
              fontWeight: 700,
            }}
          >
            {value || "N/A"}
          </span>
        );
      },
    },
    {
      Header: "Created at",
      accessor: "createdAt",
      Cell: ({ value }) => {
        // return format(new Date(value), "MM-dd-yyyy");
        if (!value) return "N/A";
        const age = formatDistanceToNow(new Date(value), { addSuffix: true });
        return <span>{age}</span>;
      },
    },
  ];

  return loading ? (
    <Spinner />
  ) : (
    <>
      <div className="flex flex-col h-screen">
        <TopBar />
        <div className="flex flex-1 overflow-hidden">
          <Sidebar />
          <main className="flex-1 p-4 overflow-y-auto">
            <div className=" mx-auto">
              <div className="flex flex-col gap-x-6 sm:flex-row sm:items-center sm:justify-end space-y-2 sm:space-y-0 sm:space-x-2 p-4">
                <div className="flex items-center border border-gray-300 rounded sm:order-1">
                  <input
                    type="text"
                    placeholder="Search"
                    className="p-2 w-full border-none outline-none"
                    value={globalFilter}
                    onChange={(e) => setGlobalFilter(e.target.value)}
                  />
                  <div className="p-2">
                    <FaSearch className="text-gray-500" />
                  </div>
                </div>
              </div>
              {tickets?.length > 0 ? (
                <Table
                  data={tickets}
                  columns={TableColumns}
                  numberOptions={numberOptions}
                  dataFun={handleData}
                  globalFilter={globalFilter}
                  setGlobalFilter={setGlobalFilter}
                />
              ) : (
                <div className="flex justify-center text-3xl font-semibold  text-neutral-600">
                  {" "}
                  No Tickets Found!
                </div>
              )}
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

TicketsOpen.propTypes = {
  user: PropTypes.object,
  tickets: PropTypes.array,
  loading: PropTypes.bool.isRequired,
  loadOpenTicketsDep: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  loading: state.tickets.openTicketsLoading,
  tickets: state.tickets.openTickets,
  user: state.auth.user,
});

export default connect(mapStateToProps, { loadOpenTicketsDep })(TicketsOpen);
